<template>
  <div class="box">
    <!-- 顶部导航 start -->
    <nav-bar />
    <!-- banner start -->
    <div class="pcban">
      <banner
        :bannerSrc="require('../../assets/images/banner_1.png')"
        isnum="index"
      />
    </div>
    <div class="medban">
      <banner
        :bannerSrc="require('../../assets/images/banner_1.png')"
        isnum="index"
      />
    </div>
    <!-- about start -->
    <in-about />
    <!-- 托管业务 start -->
    <in-custody-business />
    <!-- 最新资讯 start -->
    <latest-informations />
    <!-- 页脚 start -->
    <footers />
  </div>
</template>
<script>
import NavBar from "@/components/NavBar";
import Banner from "@/components/Banner";
import Footers from "@/components/Footer";
import InAbout from "./component/InAbout";
import InCustodyBusiness from "./component/InCustodyBusiness";
import LatestInformations from "./component/LatestInformations";

export default {
  name: "Index",
  components: {
    NavBar,
    Banner,
    Footers,
    InAbout,
    InCustodyBusiness,
    LatestInformations,
  },
  data() {
    return {};
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.$wow.init();
    });
  },
  destroyed() {
    location.reload();
  },
};
</script>
<style scoped>
.box {
  width: 100%;
  display: block;
  position: relative;
}
.pcban {
  display: none;
}
.medban {
  display: none;
}
@media only screen and (max-width: 1920px) {
  .pcban {
    display: block;
  }
  .medban {
    display: none;
  }
}
@media only screen and (max-width: 425px) {
  .pcban {
    display: none;
  }
  .medban {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Index/index.vue